import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CalendarCheck, ClipboardList, CalendarRange, Target } from "lucide-react";
import LeMeetings from "@/pages/LeMeetings";
import LeActionPlan from "@/pages/LeActionPlan";
import LeYearWheel from "@/pages/LeYearWheel";
import LeGoals from "@/pages/LeGoals";

const TABS = [
  { key: "moeder", label: "Møder & referater", icon: CalendarCheck, C: LeMeetings },
  { key: "maal", label: "Kvalitets- & miljømål", icon: Target, C: LeGoals },
  { key: "handlingsplan", label: "Handlingsplan", icon: ClipboardList, C: LeActionPlan },
  { key: "aarshjul", label: "Dagsorden / årshjul", icon: CalendarRange, C: LeYearWheel },
];

export default function Ledelse() {
  const nav = useNavigate(); const loc = useLocation();
  const [tab, setTab] = useState(() => sessionStorage.getItem("le_tab") || "moeder");
  const pick = (k) => { setTab(k); sessionStorage.setItem("le_tab", k); if (loc.search) nav(loc.pathname, { replace: true }); };
  const Active = TABS.find((t) => t.key === tab)?.C || LeMeetings;
  return (
    <div className="space-y-6" data-testid="ledelse-page">
      <div className="inline-flex rounded-2xl border border-[#EBE8E3] bg-white p-1 flex-wrap">
        {TABS.map((t) => (
          <button key={t.key} data-testid={`le-tab-${t.key}`} onClick={() => pick(t.key)}
            className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-colors ${tab === t.key ? "bg-[#A83232] text-white" : "text-stone-600 hover:bg-[#F3F1EC]"}`}>
            <t.icon className="h-4 w-4" /> {t.label}
          </button>
        ))}
      </div>
      <Active />
    </div>
  );
}
